<button
  mat-button
  [matMenuTriggerFor]="menu"
  [disableRipple]="true"
  class="currency-selector-button"
  aria-label="content-language"
>
  <div class="flex items-center text-sm">
    <p>{{ selectedCurrency.key }}</p>

    <svg
      class="w-2.5 h-2.5 ms-3"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 10 6"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="m1 1 4 4 4-4"
      />
    </svg>
  </div>
</button>
<mat-menu #menu="matMenu" class="flex flex-col ms-4">
  @for( currency of currencies ; track $index){
  <button mat-menu-item (click)="selectCurrency(currency)">
    <div
      class="flex items-center rtl:flex-row-reverse gap-1 px-2 py-2.5 text-sm hover:bg-light-blue rounded-lg transition-colors w-36"
    >
      <span>{{ currency.name }} </span>
      <span>({{ currency.key }})</span>
    </div>
  </button>
  }
</mat-menu>
